import React from "react";
import { kbdEvent } from "../utils/Utils";
import { SettingsIcon } from "../utils/Icons";
import ToolTip from "./ToolTip";

export default function IconNav({ nav = [], shim = false }) {

    
    const drawItem = (item, index) => {
        const {
            text = "",
            icon = <SettingsIcon />,
            key = false,
            type = "",
            action = () => {},
            disabled = false
        } = item;

        if (type === "shim") {
            return <div key={index} className="icon-nav-divider" />;
        }

        return (
            <ToolTip text={(key?.label ) ? <>{text} &nbsp; <span style={{"opacity" : ".7"}}>{key.label}</span></> : text} key={index}>
            <div
                key={index}
                className={`icon-nav-item ${disabled ? "disabled" : ""}`}
                onClick={() => {
                    if (disabled) return;
                    if (key) kbdEvent(key);
                    else action();
                }}
            >
                <div className="icon-nav-icon">{icon}</div>
                <div className="icon-nav-label">{text}</div>
            </div>
            </ToolTip>
        );
    };

    return (
        <div className="icon-nav">
            <div className="icon-nav-group">
                {nav.filter(item => !item.right && item?.text).map(drawItem)}
            </div>

            <div className="icon-nav-group">
                {nav.filter(item => item.right && item?.text).map(drawItem)}
            </div>
        </div>
    );
}